import { envConfig } from '#/config/env';

const firestoreConfig = envConfig.FIRESTORE_CONFIG;
export const FIREBASE_SDK_VERSION = '10.12.3';
const firebaseScriptBase = `https://www.gstatic.com/firebasejs/${FIREBASE_SDK_VERSION}`;

export default {
  FIREBASE_APP_SCRIPT: `${firebaseScriptBase}/firebase-app-compat.js`,
  FIREBASE_STORE_SCRIPT: `${firebaseScriptBase}/firebase-firestore-compat.js`,
  FIREBASE_ANALYTICS_SCRIPT: `${firebaseScriptBase}/firebase-analytics-compat.js`,
  FIREBASE_INSTALLATIONS_SCRIPT: `${firebaseScriptBase}/firebase-installations-compat.js`,
  apiKey: firestoreConfig.FIRESTORE_KEY,
  authDomain: firestoreConfig.FIRESTORE_DOMAIN,
  projectId: firestoreConfig.FIRESTORE_PROJECT,
  storageBucket: firestoreConfig.FIRESTORE_STORAGE,
  messagingSenderId: firestoreConfig.FIRESTORE_MESSENGER,
  appId: firestoreConfig.FIRESTORE_APP,
  measurementId: firestoreConfig.FIRESTORE_MEASUREMENT,
};
